import { takeLatest, call, put } from 'redux-saga/effects';
import URLS from '../constants/urls';
import { callApi } from '../utils/api';
import * as bankAction from '../actions/bankAction';
import * as SnackbarAction from '../actions/snackbarAction';
import { setLoader } from '../actions/loaderAction';

function* fetchBankAccounts(action) {
  try {
    const response = yield call(callApi, URLS.SEARCH, 'GET', action.payload);
    yield put(bankAction.setBankAccountList(response.res_data));
    yield put(setLoader(false));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* connectPlaid(action) {
  try {
    const response = yield call(
      callApi,
      URLS.CONNECT_PLAID,
      'POST',
      action.payload,
    );
    if (response.res_str) {
      yield put(
        SnackbarAction.openSnackbar({
          message: response.res_str,
          type: 'success',
        }),
      );
    }

    yield put(
      bankAction.getBankAccounts({
        content_type: 'bank_account',
        offset: '0',
        limit: '100',
      }),
    );
  } catch (error) {
    /* yield put(
      SnackbarAction.openSnackbar({
        message: error,
        type: 'error',
      }),
    ); */
  }
}

function* updateBankAccount(action) {
  try {
    const response = yield call(
      callApi,
      URLS.UPDATE_BANK_ACCOUNT,
      'POST',
      action.payload,
    );
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );

    yield put(
      bankAction.getBankAccounts({
        content_type: 'bank_account',
        offset: '0',
        limit: '100',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* bankSaga() {
  yield takeLatest('SEARCH_BANKS', fetchBankAccounts);
  yield takeLatest('CONNECT_PLAID', connectPlaid);
  yield takeLatest('UPDATE_BANK_ACCOUNT', updateBankAccount);
}
